import { contactUrl } from '@frontend/constants';
import { Anchor } from '@frontend/web-react/components/Primitives/Anchor';
import { YStack } from '@frontend/web-react/components/Primitives/Containers/Stacks/YStack';
import { Text } from '@frontend/web-react/components/Primitives/Texts/Text';
import { Title } from '@frontend/web-react/components/Primitives/Texts/Title';
import { NavLinkButton } from '@frontend/web/components/Navigation/NavLinks/NavLinkButton';
import { useAuthentication } from '@frontend/web/hooks/useAuthentication';

export type GenericErrorPageProps = {
  giantText?: string;
  subtitle?: string;
  title?: string;
};
export const GenericErrorPage = ({
  giantText = 'This page took a duck dive.',
  subtitle = '',
  title = "But don't worry, we’ll bring you back up.",
}: GenericErrorPageProps) => {
  const { isAuthenticated } = useAuthentication();
  return (
    <YStack className="px-md flex min-h-screen w-full">
      <YStack alignItems="center" className="gap-y-xxl flex-1" justifyContent="center">
        <YStack alignItems="center">
          <Title
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            className="text-[100px] font-extrabold uppercase italic leading-[130px] max-w-4xl"
            textAlign="center"
            type="h1"
          >
            {giantText}
          </Title>
          <Title className="text-h1 uppercase italic" type="h2">
            {title}
          </Title>
          {subtitle ? <Text type="p-lg">{subtitle}</Text> : null}
        </YStack>
        <YStack alignItems="center" gapY="lg">
          <YStack alignItems="center" gapY="xl">
            {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
            <NavLinkButton className="min-w-[200px]" to={isAuthenticated ? '/app' : '/login'}>
              {isAuthenticated ? 'Back to Dashboard' : 'Login'}{' '}
            </NavLinkButton>
            <Anchor href={contactUrl} newTab type="h5">
              Get Help
            </Anchor>
          </YStack>
        </YStack>
      </YStack>
    </YStack>
  );
};
